import { render, staticRenderFns } from "./EventBookingComparisonComponent.vue?vue&type=template&id=33bf488a"
import script from "./EventBookingComparisonComponent.vue?vue&type=script&lang=js"
export * from "./EventBookingComparisonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports